import React from 'react';
import JobPostManagement from '../../components/company/JobPostManagement/JobPostManagement.jsx';

const JobPosts = () => {
  return (
    <div>
      <JobPostManagement />
    </div>
  );
};

export default JobPosts;